module.exports = __webpack_public_path__ + "img/student_mascot.4c46a6de.png";